import React from 'react'
import Svg, { Circle, Path, Rect } from 'react-native-svg'

interface VehicleCategoryIconProps {
  size?: number
  color?: string
  strokeWidth?: number
  fill?: string
}

function CategorySvg({
  size,
  color,
  strokeWidth,
  fill,
  children,
}: Required<VehicleCategoryIconProps> & { children: React.ReactNode }) {
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {children}
    </Svg>
  )
}

export function AllCarsIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth = 1.8,
  fill = 'none',
}: VehicleCategoryIconProps) {
  return (
    <CategorySvg size={size} color={color} strokeWidth={strokeWidth} fill={fill}>
      <Path d="M3.2 14.4h17.6l-.9-3.1-3.2-.8-2.6-3H9.2l-2.4 3-2.8.8-.8 3.1Z" />
      <Path d="M8.6 10.5h6.9" />
      <Circle cx={7.2} cy={16.4} r={1.8} />
      <Circle cx={16.8} cy={16.4} r={1.8} />
      <Path d="M3.9 14.4h1.6M9.1 14.4h5.8M18.5 14.4h1.6" />
    </CategorySvg>
  )
}

export function PremiumVehicleIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth = 1.8,
  fill = 'none',
}: VehicleCategoryIconProps) {
  return (
    <CategorySvg size={size} color={color} strokeWidth={strokeWidth} fill={fill}>
      <Path d="M6.8 16.1h10.4l.9-7-3.8 3.1L12 7.2l-2.3 5-3.8-3.1.9 7Z" />
      <Path d="M7.9 18.4h8.2" />
      <Circle cx={12} cy={13.2} r={1.1} />
    </CategorySvg>
  )
}

export function ElectricVehicleIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth = 1.8,
  fill = 'none',
}: VehicleCategoryIconProps) {
  return (
    <CategorySvg size={size} color={color} strokeWidth={strokeWidth} fill={fill}>
      <Path d="M4 15.1h16l-1-3-3.2-.8-2.4-2.8H9.5l-2.3 2.8-2.4.8-.8 3Z" />
      <Path d="M9.2 11.3h5.1" />
      <Path d="M13.4 4.9 10.7 10h3.2l-2 4.5 4.8-5.8h-3.2l1.9-3.8Z" />
      <Circle cx={7.5} cy={16.9} r={1.6} />
      <Circle cx={16.7} cy={16.9} r={1.6} />
    </CategorySvg>
  )
}

export function SuvVehicleIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth = 1.8,
  fill = 'none',
}: VehicleCategoryIconProps) {
  return (
    <CategorySvg size={size} color={color} strokeWidth={strokeWidth} fill={fill}>
      <Path d="M3.2 15h17.6v-3.5l-1.9-1.3h-2.8L13.7 7H8.2l-2.4 3.2H4.7l-1.5 1.4V15Z" />
      <Path d="M8.3 7h5.4M10.6 10.2V7M13.7 10.2h2.4" />
      <Circle cx={7.3} cy={16.8} r={1.8} />
      <Circle cx={16.8} cy={16.8} r={1.8} />
      <Path d="M3.8 15h1.6M9.2 15h5.7M18.7 15h1.6" />
    </CategorySvg>
  )
}

export function SedanIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth = 1.8,
  fill = 'none',
}: VehicleCategoryIconProps) {
  return (
    <CategorySvg size={size} color={color} strokeWidth={strokeWidth} fill={fill}>
      <Path d="M3 15h18l-.9-2.8-3.8-.9-2.4-2.5H9.8l-2.4 2.5-3.5.9L3 15Z" />
      <Path d="M8.7 11.3h6.8M12 8.8v2.5" />
      <Circle cx={7.4} cy={16.7} r={1.7} />
      <Circle cx={16.6} cy={16.7} r={1.7} />
      <Path d="M3.9 15h1.5M9.3 15h5.4M18.6 15h1.5" />
    </CategorySvg>
  )
}

export function PickupIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth = 1.8,
  fill = 'none',
}: VehicleCategoryIconProps) {
  return (
    <CategorySvg size={size} color={color} strokeWidth={strokeWidth} fill={fill}>
      <Path d="M3.2 15h17.6v-3.7h-5.9l-2-3.5H8.6l-2 3.5H4.5l-1.3 1.4V15Z" />
      <Path d="M15 11.3h5.8M8.8 7.8v3.5h4.3" />
      <Path d="M4.5 11.3h2.1" />
      <Circle cx={7.2} cy={16.8} r={1.8} />
      <Circle cx={17.2} cy={16.8} r={1.8} />
      <Path d="M3.8 15h1.5M9 15h6M19 15h1.5" />
    </CategorySvg>
  )
}

export function MicrobusIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth = 1.8,
  fill = 'none',
}: VehicleCategoryIconProps) {
  return (
    <CategorySvg size={size} color={color} strokeWidth={strokeWidth} fill={fill}>
      <Rect x={3.2} y={7.5} width={17.6} height={8.2} rx={2.1} />
      <Path d="M6.1 10h3M11 10h3M15.8 10h2.1" />
      <Path d="M5.6 12.8h12.8" />
      <Circle cx={7.4} cy={17.2} r={1.5} />
      <Circle cx={16.6} cy={17.2} r={1.5} />
    </CategorySvg>
  )
}

export function FunVehicleIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth = 1.8,
  fill = 'none',
}: VehicleCategoryIconProps) {
  return (
    <CategorySvg size={size} color={color} strokeWidth={strokeWidth} fill={fill}>
      <Path d="M4 15h15.8l-1-2.7-3.1-.8-2.1-2.5H9.8l-2.1 2.5-2.7.8L4 15Z" />
      <Path d="M10 11.5h4.7" />
      <Circle cx={7.5} cy={16.8} r={1.7} />
      <Circle cx={16.3} cy={16.8} r={1.7} />
      <Path d="M18.5 6.5v2.4M17.3 7.7h2.4M6.9 6.7l.6 1.1M8.3 6.1l-1.2.6" />
    </CategorySvg>
  )
}

export function WorkVehicleIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth = 1.8,
  fill = 'none',
}: VehicleCategoryIconProps) {
  return (
    <CategorySvg size={size} color={color} strokeWidth={strokeWidth} fill={fill}>
      <Path d="M3.3 15h17.4v-3.4h-5.7l-2-3.4H8.7l-2 3.4H4.5l-1.2 1.4V15Z" />
      <Path d="M15 11.6h5.7M8.9 8.2v3.4h4.2" />
      <Rect x={15.7} y={8.3} width={3.3} height={2.2} rx={0.5} />
      <Path d="M16.5 8.3v-.8h1.7v.8" />
      <Circle cx={7.2} cy={16.8} r={1.8} />
      <Circle cx={17.2} cy={16.8} r={1.8} />
    </CategorySvg>
  )
}

export function MotorcycleVehicleIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth = 1.8,
  fill = 'none',
}: VehicleCategoryIconProps) {
  return (
    <CategorySvg size={size} color={color} strokeWidth={strokeWidth} fill={fill}>
      <Circle cx={5.8} cy={16.5} r={2.4} />
      <Circle cx={18.2} cy={16.5} r={2.4} />
      <Path d="M8.2 16.5h3.1l2.5-4.4h2.1l2.3 4.4" />
      <Path d="M10.5 12.1h3.3l-1.5-2.3H9.4" />
      <Path d="M15.8 9.4h2.2l1.3 2.3" />
      <Path d="M5.8 16.5 8 12.9h2.3" />
    </CategorySvg>
  )
}
